// Owner rule (26-10-2569): every date on every screen is dd-mm-yyyy with the Buddhist-era year, e.g. 25-10-2569.
// Values sent to / read from the API stay ISO (yyyy-mm-dd); only what people see and type uses this format.

const BE_OFFSET = 543;
const ISO_DATE = /^(\d{4})-(\d{2})-(\d{2})$/;

// calendar parts of a moment, in Thailand time
function bangkokParts(date) {
  const parts = {};
  new Intl.DateTimeFormat("en-GB", {
    timeZone: "Asia/Bangkok",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hourCycle: "h23",
  })
    .formatToParts(date)
    .forEach((p) => { parts[p.type] = p.value; });
  return parts;
}

const pad = (n) => String(n).padStart(2, "0");

// "2026-10-25" | Date | ISO date-time → "25-10-2569" ("" when empty / invalid)
export function formatDate(value) {
  if (value === undefined || value === null || value === "") return "";
  const iso = typeof value === "string" ? value.match(ISO_DATE) : null;
  if (iso) return `${iso[3]}-${iso[2]}-${Number(iso[1]) + BE_OFFSET}`;
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return String(value);
  const p = bangkokParts(d);
  return `${p.day}-${p.month}-${Number(p.year) + BE_OFFSET}`;
}

// moment → "25-10-2569 14:30"
export function formatDateTime(value) {
  if (value === undefined || value === null || value === "") return "";
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return String(value);
  const p = bangkokParts(d);
  return `${p.day}-${p.month}-${Number(p.year) + BE_OFFSET} ${p.hour}:${p.minute}`;
}

// typed "25-10-2569" (also 25/10/2569, 25.10.2569, or a 2026 year) → "2026-10-25"; null when not a real date
export function parseDisplayDate(text) {
  const m = String(text || "").trim().match(/^(\d{1,2})[-/.](\d{1,2})[-/.](\d{4})$/);
  if (!m) return null;
  const day = Number(m[1]);
  const month = Number(m[2]);
  let year = Number(m[3]);
  if (year >= 2400) year -= BE_OFFSET;
  const d = new Date(Date.UTC(year, month - 1, day));
  if (d.getUTCFullYear() !== year || d.getUTCMonth() !== month - 1 || d.getUTCDate() !== day) return null;
  return `${year}-${pad(month)}-${pad(day)}`;
}
